import React from "react";
import {Button} from "antd";
import {ColumnsType} from "antd/es/table";
import {Translate} from "../../../../../../hooks/translate.hook";
import {InvoiceData} from "../../../../../../models/documents/invoices/invoice-data/invoice.data";

export const columnsFactory = (t: Translate): ColumnsType<InvoiceData> => [
    {
        title: t("INVOICES.NUMBER", {defaultValue: "Document number"}),
        dataIndex: "docNumber",
        key: "docNumber",
    },
    {
        title: t("ACTION", {defaultValue: "Action"}),
        key: "action",
        align: "right",
        width: 100,
        render: (_, invoice) => (
            <Button
                type="link"
                href={`/invoices/${invoice.id}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {t("OPEN", {defaultValue: "Open"})}
            </Button>
        ),
    },
];
